// extracted by mini-css-extract-plugin
export default {"container":"BaseNativeAppBar_container__q-Fr9","title":"BaseNativeAppBar_title__lgvLQ","searchBox":"BaseNativeAppBar_searchBox__J8I3y"};